import { all } from "redux-saga/effects";
import authSaga from "./auth";
import clubSaga from "./club";
import marketSaga from "./market";
import userSaga from "./user";
import courtSaga from "./court";
import bookingSaga from "./booking";
import branchSaga from "./branch";

export default function* rootSaga(): Generator {
  yield all([
    authSaga(),
    clubSaga(),
    marketSaga(),
    userSaga(),
    courtSaga(),
    bookingSaga(),
    branchSaga(),
  ]);
}
